import {
	IonButton,
	IonCheckbox,
	IonCol,
	IonImg,
	IonItem,
	IonLabel,
	IonModal,
	IonRadio,
	IonRadioGroup,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import * as constants from "../constants";

interface AddonModalProps {
	showAddon: boolean;
	oilGrade: any;
	setShowAddon: Function;
	addOnSections: Array<any>;
	setOilGrade: Function;
	setSelectedAddons: Function;
	submitData: Function;
	selectedAddons: Array<any>;
	restoreState?: Function;
}

export const AddOnModal: React.FC<AddonModalProps> = ({
	showAddon = false,
	selectedAddons = [],
	oilGrade = {},
	setShowAddon = () => null,
	addOnSections = [],
	setOilGrade = () => null,
	setSelectedAddons = () => null,
	submitData = () => null,
	restoreState = () => null,
}) => {
	return (
		<IonModal
			isOpen={showAddon}
			onDidDismiss={() => {
				setShowAddon(false);
				restoreState();
			}}
			cssClass="cart-web-pop"
			backdropDismiss={true}
		>
			<div className="modal_body model_container">
				<div className="modal_panel customize_panel model_header web-header">
					<IonLabel className="modal_header vehicle_header">
						{constants.CUSTOMIZE_YOUR_SERVICE}
					</IonLabel>
					<img
						onClick={() => setShowAddon(false)}
						src="/images/close_popup.svg"
						className="close_icon"
					/>
				</div>
				<div className="model_panel_body">
					{addOnSections.length &&
						addOnSections.map((ele: any, index: any) =>
							ele.selectionType === "Multiple" ? (
								<div className="panel_body" key={index}>
									<IonLabel className="sd_addOns">{constants.ADD_ONS}</IonLabel>
									{ele.items.map((addon: any, ind: any) => (
										<div className="sd_row_spbtwn" key={ind}>
											<div className="sd_rowcenter">
												<IonCheckbox
													color="lightgreen"
													checked={selectedAddons
														.map((ele: any) => ele.addOnId)
														.includes(addon.addOnId)}
													onIonChange={(e: any) => {
														setSelectedAddons(addon);
													}}
													mode="md"
												/>
												<IonLabel
													className={
														selectedAddons
															.map((ele: any) => ele.addOnId)
															.includes(addon.addOnId)
															? "active_sd_addon_option"
															: "sd_addon_option"
													}
												>
													{addon.displayName}
												</IonLabel>
												{addon.isRecommended && (
													<IonLabel className="sd_autorecom">{`(TSERV Recommended)`}</IonLabel>
												)}
											</div>
											<IonLabel
												className={
													selectedAddons
														.map((ele: any) => ele.addOnId)
														.includes(addon.addOnId)
														? "active_sd_autoprice"
														: "sd_autoprice"
												}
											>{`${constants.RupeeSymbol} ${Number(
												addon.price.amount
											)}`}</IonLabel>
										</div>
									))}
								</div>
							) : (
								<div className="panel_body" key={index}>
									<IonLabel className="sd_addOns">{constants.OIL_GRADE}</IonLabel>
									<IonRadioGroup value={oilGrade.displayName}>
										<div className="radio_btns">
											{ele.items.map((type: any, index: any) => (
												<IonItem key={index} lines="none">
													<IonLabel
														className="radio_btn_text"
														style={{
															fontSize: 12,
															fontWeight: 400,
															color:
																type.displayName === oilGrade.displayName
																	? "#444444"
																	: "#999999",
														}}
													>
														{type.displayName}
													</IonLabel>
													<IonRadio
														className="mg_right_15"
														slot="start"
														value={type.displayName}
														onClick={() => {
															setOilGrade(type);
														}}
														mode="md"
													/>
												</IonItem>
											))}
										</div>
									</IonRadioGroup>
								</div>
							)
						)}
				</div>
				<div className="cart_service_btn model_container_fixed">
					<IonButton
						color="primary"
						className="width_btn"
						onClick={() => {
							submitData();
						}}
					>
						<IonLabel color="light">{constants.CONTINUE}</IonLabel>
					</IonButton>
				</div>
			</div>
		</IonModal>
	);
};
export default AddOnModal;
